import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { TriggersPage } from '@/features/orchestration/triggers-page';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Déclencheurs sur événement d'un projet (2026-10-10, ADR 0046) : fin d'un run, objet déposé, webhook signé. */
export const Route = createFileRoute('/$tenant/projects/$projectId/triggers/')({
  component: TriggersRoute,
});

function TriggersRoute() {
  const { tenant, projectId } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      projectId={projectId}
      activeItem="triggers"
      crumbs={[{ label: t('nav.items.triggers') }]}
    >
      <TriggersPage tenantId={tenant} projectId={projectId} />
    </ConsoleShell>
  );
}
